<!-- Template -->

<template>
    <div class="header-container">
        <header class="container pl-0 pr-0">
            <a href="#" @click.prevent="goToVisionRT()"><img src="@/assets/images/logo.png"/></a>
            <p v-if="processing">You are now being logged out of VisionRT Portal ...</p>
        </header>
    </div>
</template>

<!-- Script -->

<script>
    import store from '@/store/store';

    export default {
        name: 'Header',

        data(){
            return{
                processing:false
            }
        },

        methods:{
            goToVisionRT(){
                this.processing = true;
                setTimeout(function(){
                    this.processing = false;
                    store.dispatch('session/reset');             
                    window.location = 'https://www.visionrt.com/';
                }, 5000);
            }
        }
    }
</script>

